import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

export default function StorePartner() {
  const [stores, setStores] = useState([])
  const [loading, setLoading] = useState(true)
  const [showModal, setShowModal] = useState(false)
  const [selectedStore, setSelectedStore] = useState(null)
  const [form, setForm] = useState({ name: '', owner: '', phone: '', area: '', commission_rate: 15 })

  useEffect(() => { loadStores() }, [])

  const loadStores = () => {
    setLoading(true)
    fetch(`${API}/partners/store`)
      .then(r => r.json())
      .then(d => { if (d.success) setStores(d.data || []) })
      .catch(() => {
        setStores([
          { id: 'SP001', name: '朝阳门店', owner: '王五', phone: '139****8001', area: '北京朝阳', commission_rate: 15, sales: 12500, commission: 1875, status: 'active' },
          { id: 'SP002', name: '海淀门店', owner: '赵六', phone: '139****8002', area: '北京海淀', commission_rate: 15, sales: 8900, commission: 1335, status: 'active' },
          { id: 'SP003', name: '浦东门店', owner: '孙七', phone: '139****8003', area: '上海浦东', commission_rate: 18, sales: 15600, commission: 2808, status: 'active' },
        ])
      })
      .finally(() => setLoading(false))
  }

  const openAdd = () => {
    setSelectedStore(null)
    setForm({ name: '', owner: '', phone: '', area: '', commission_rate: 15 })
    setShowModal(true)
  }

  const openEdit = (s) => {
    setSelectedStore(s)
    setForm({ name: s.name, owner: s.owner || '', phone: s.phone, area: s.area || '', commission_rate: s.commission_rate })
    setShowModal(true)
  }

  const handleSave = () => {
    if (!form.name || !form.phone) { alert('请填写门店名称和联系电话'); return }
    if (selectedStore) {
      setStores(prev => prev.map(s => s.id === selectedStore.id ? { ...s, ...form } : s))
      alert('门店已更新')
    } else {
      setStores(prev => [...prev, { id: 'SP' + Date.now(), ...form, sales: 0, commission: 0, status: 'active' }])
      alert('门店已添加')
    }
    setShowModal(false)
  }

  const handleDelete = (s) => {
    if (!confirm(`确定删除门店 "${s.name}" 吗？`)) return
    setStores(prev => prev.filter(x => x.id !== s.id))
    alert('已删除')
  }

  const resetPassword = (s) => {
    if (!confirm(`确定重置 ${s.name} 的密码？`)) return
    const tempPwd = Math.random().toString(36).slice(-8)
    alert(`新密码：${tempPwd}\n请告知门店负责人并提醒修改密码`)
  }

  const toggleStatus = (s) => {
    const newStatus = s.status === 'active' ? 'disabled' : 'active'
    if (!confirm(`确定${newStatus === 'active' ? '启用' : '禁用'}门店 ${s.name}？`)) return
    setStores(prev => prev.map(x => x.id === s.id ? { ...x, status: newStatus } : x))
    alert('状态已更新')
  }

  const totalSales = stores.reduce((s, st) => s + (st.sales || 0), 0)
  const totalCommission = stores.reduce((s, st) => s + (st.commission || 0), 0)

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <div>
          <h2 style={{ fontSize: 20, marginBottom: 4 }}>🏪 门店合伙人</h2>
          <p style={{ color: '#666', fontSize: 13 }}>管理线下门店合伙人，负责销售和客户服务</p>
        </div>
        <button onClick={openAdd} style={{ padding: '10px 20px', background: '#722ed1', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 'bold' }}>
          + 添加门店
        </button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 24 }}>
        <div style={card}><div style={{ color: '#999', fontSize: 12 }}>门店总数</div><div style={{ fontSize: 28, color: '#1890ff' }}>{stores.length}</div></div>
        <div style={card}><div style={{ color: '#999', fontSize: 12 }}>本月销售</div><div style={{ fontSize: 28, color: '#52c41a' }}>¥{totalSales.toLocaleString()}</div></div>
        <div style={card}><div style={{ color: '#999', fontSize: 12 }}>本月佣金</div><div style={{ fontSize: 28, color: '#fa8c16' }}>¥{totalCommission.toLocaleString()}</div></div>
        <div style={card}><div style={{ color: '#999', fontSize: 12 }}>待结算</div><div style={{ fontSize: 28, color: '#eb2f96' }}>¥{(totalCommission * 0.1).toLocaleString()}</div></div>
      </div>

      {/* 添加/编辑弹窗 */}
      {showModal && (
        <div style={{ background: '#fff', borderRadius: 8, padding: 24, marginBottom: 20, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
          <h3 style={{ marginBottom: 16 }}>{selectedStore ? '编辑门店' : '添加门店'}</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12 }}>
            <input type="text" placeholder="门店名称" value={form.name} onChange={e => setForm({...form, name: e.target.value})} style={input} />
            <input type="text" placeholder="负责人" value={form.owner} onChange={e => setForm({...form, owner: e.target.value})} style={input} />
            <input type="text" placeholder="联系电话" value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} style={input} />
            <input type="text" placeholder="所在区域" value={form.area} onChange={e => setForm({...form, area: e.target.value})} style={input} />
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 12 }}>
            <span>佣金比例：</span>
            <input type="number" value={form.commission_rate} onChange={e => setForm({...form, commission_rate: parseInt(e.target.value)})} style={{ ...input, width: 80 }} />
            <span>%</span>
          </div>
          <div style={{ display: 'flex', gap: 12, marginTop: 16 }}>
            <button onClick={handleSave} style={{ padding: '10px 24px', background: '#52c41a', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}>保存</button>
            <button onClick={() => setShowModal(false)} style={{ padding: '10px 24px', background: '#999', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}>取消</button>
          </div>
        </div>
      )}

      <div style={{ background: '#fff', borderRadius: 8, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#fafafa' }}>
              {['编号', '门店名称', '负责人', '电话', '区域', '佣金比例', '本月销售', '本月佣金', '状态', '操作'].map(h => (
                <th key={h} style={th}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {stores.map(s => (
              <tr key={s.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                <td style={td}>{s.id}</td>
                <td style={{ ...td, fontWeight: 600 }}>{s.name}</td>
                <td style={td}>{s.owner || '-'}</td>
                <td style={{ ...td, color: '#666' }}>{s.phone}</td>
                <td style={{ ...td, color: '#666' }}>{s.area || '-'}</td>
                <td style={{ ...td, color: '#52c41a' }}>{s.commission_rate || 15}%</td>
                <td style={{ ...td, color: '#333' }}>¥{(s.sales || 0).toLocaleString()}</td>
                <td style={{ ...td, color: '#f5222d', fontWeight: 600 }}>¥{(s.commission || 0).toLocaleString()}</td>
                <td style={td}>
                  <span style={{ padding: '2px 8px', borderRadius: 10, fontSize: 11, background: s.status === 'active' ? '#f6ffed' : '#fff1f0', color: s.status === 'active' ? '#52c41a' : '#ff4d4f' }}>
                    {s.status === 'active' ? '营业中' : '已停业'}
                  </span>
                </td>
                <td style={td}>
                  <button onClick={() => openEdit(s)} style={{ ...btn, background: '#1890ff', color: '#fff' }}>编辑</button>
                  <button onClick={() => resetPassword(s)} style={{ ...btn, background: '#faad14', color: '#fff', marginLeft: 4 }}>重置密码</button>
                  <button onClick={() => toggleStatus(s)} style={{ ...btn, background: s.status === 'active' ? '#ff4d4f' : '#52c41a', color: '#fff', marginLeft: 4 }}>{s.status === 'active' ? '停业' : '开业'}</button>
                  <button onClick={() => handleDelete(s)} style={{ ...btn, background: '#8c8c8c', color: '#fff', marginLeft: 4 }}>删除</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

const card = { background: '#fff', borderRadius: 8, padding: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }
const th = { padding: 12, textAlign: 'left', fontSize: 13, color: '#666' }
const td = { padding: 12, fontSize: 13 }
const btn = { padding: '4px 8px', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12 }
const input = { padding: 10, borderRadius: 6, border: '1px solid #ddd' }
